import Header from './sections/header-section';
import Footer from './sections/footer-section';
import HeroSection from './sections/hero-section';
import AboutSection from './sections/about-section';
import CareSection from './sections/care-section';
import VisitSection from './sections/visit-section';

function App() {
  return (
    <div id="top" className="min-h-screen bg-cream text-ink">
      <a
        href="#about"
        className="sr-only focus:not-sr-only focus:absolute focus:left-3 focus:top-3 focus:z-50 focus:rounded-pill focus:bg-plum focus:px-4 focus:py-2 focus:text-petal"
      >
        Skip to content
      </a>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <CareSection />
        <VisitSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
